import { render, staticRenderFns } from "./DesignTokenEditor.vue?vue&type=template&id=739e6b81&scoped=true&lang=pug&"
import script from "./DesignTokenEditor.vue?vue&type=script&lang=js&"
export * from "./DesignTokenEditor.vue?vue&type=script&lang=js&"
import style0 from "./DesignTokenEditor.vue?vue&type=style&index=0&id=739e6b81&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739e6b81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('739e6b81', component.options)
    } else {
      api.reload('739e6b81', component.options)
    }
    module.hot.accept("./DesignTokenEditor.vue?vue&type=template&id=739e6b81&scoped=true&lang=pug&", function () {
      api.rerender('739e6b81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/design_token/DesignTokenEditor.vue"
export default component.exports